var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeShippingBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--shipping-box_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h20v20H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--shipping-box_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.374 20.307V14.36l-5.208-3.016v5.804c0 .043.01.083.032.12.021.038.053.07.096.096l5.08 2.944zm1.25 0l5.08-2.944a.276.276 0 00.097-.096.238.238 0 00.032-.12v-5.804l-5.209 3.016v5.948zm-1.378 1.364l-5.577-3.21a1.484 1.484 0 01-.753-1.301v-6.32a1.476 1.476 0 01.753-1.302l5.577-3.21a1.484 1.484 0 011.506 0l5.577 3.21a1.483 1.483 0 01.754 1.301v6.32a1.477 1.477 0 01-.754 1.302l-5.577 3.21a1.484 1.484 0 01-1.506 0zm3.966-10.255l1.933-1.109-5.018-2.902a.24.24 0 00-.128-.04.24.24 0 00-.128.04l-1.81 1.042 5.151 2.97zM14 13.282l1.938-1.122-5.146-2.974-1.937 1.121 5.145 2.975z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--shipping-box-ef1c7a46bd384531a46f670b18ff180d.svg";
export { SvgIconCircleLimeShippingBox as Component };